import { BaseModel } from "sjs-base-model";
import InfoUtentePreventivoModel from "./InfoUtentePreventivoModel";
import PreventivoQuestionarioViewModel from "./PreventivoQuestionarioViewModel";
import environment from "environment";
export default class RicercaPreventivoViewModel extends BaseModel {
    public readonly isLogged: boolean = false;
    public readonly importoRichiesto: string = "";
    public readonly codiceTipoRichiedente: string = environment.attivaPreSelezionePensionato ? "P" : "";
    public readonly dataNascita: string = "";
    public readonly dataAssunzione: string = "";
    public readonly importoNettoRedditoMensile: string = "";
    public readonly importoRata: number = 0;
    public readonly durata: number = 0;
    public readonly isSubmitted: boolean = false;
    public readonly idPreventivo: number = 0;
    public readonly codiceConvenzione: string = "";
    public readonly informazioniUtente: InfoUtentePreventivoModel = new InfoUtentePreventivoModel({});
    public readonly preventivoQuestionario: PreventivoQuestionarioViewModel = new PreventivoQuestionarioViewModel({});

    /*
     * Client-Side properties (Not from API)
     */
    // public noneApiProperties: unknown = null;
    constructor(data: Partial<RicercaPreventivoViewModel>) {
        super();

        this.update(data);
    }
}
